var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.322 15.678a1.159 1.159 0 0 1 0 1.69 1.2 1.2 0 0 1-1.69 0 5.955 5.955 0 0 1 0-8.414l4.213-4.213a5.955 5.955 0 0 1 8.414 0 5.955 5.955 0 0 1 0 8.414l-1.773 1.773a8.22 8.22 0 0 0-.476-2.88l.56-.571a3.549 3.549 0 0 0 0-5.046 3.549 3.549 0 0 0-5.047 0l-4.201 4.2a3.549 3.549 0 0 0 0 5.047Zm3.356-5.046a1.2 1.2 0 0 1 1.69 0 5.955 5.955 0 0 1 0 8.414l-4.213 4.213a5.955 5.955 0 0 1-8.414 0 5.955 5.955 0 0 1 0-8.414l1.773-1.773a8.333 8.333 0 0 0 .476 2.892l-.56.56a3.549 3.549 0 0 0 0 5.045 3.549 3.549 0 0 0 5.047 0l4.201-4.2a3.549 3.549 0 0 0 0-5.047 1.159 1.159 0 0 1 0-1.69Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLink);
export default __webpack_public_path__ + "static/media/social_link.106dad07.svg";
export { ForwardRef as ReactComponent };